













































import { Component, Mixins, Prop } from 'vue-property-decorator';
import CreateDisplayMessage from '@/shared/CreateDisplayMessage';
import AccountIcon from '@/components/common/AccountIcon.vue';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Activity } from '@/@types/activity';
import { vxm } from '@/store';
dayjs.extend(relativeTime);

@Component({
  components: {
    AccountIcon,
  },
})
export default class ActivityListDrawer extends Mixins(CreateDisplayMessage) {
  @Prop({ required: true, default: []})
  private activities!: Activity[];
  private isActivityLoading: boolean = true;
  private listItemPixelHeight: number = 123;

  // TODO:パターンを網羅する
  private activityTitle(kindCd: string) {
    if (kindCd === 'add_task') {
      return '課題を追加しました';
    }
    return '';
  }
}
